<mat-form-field appearance="outline">
    <mat-label for="searchFilter">{{ label }}</mat-label>
  
    <mat-chip-grid #chipGrid>
      <!-- Render selected filters as chips -->
      <mat-chip-row 
        *ngFor="let filter of selectedFilters" 
        [title]="(chipHelpers[filter.chip!] ?? filter.chip) + (filter.isNegated ? ' (negated)' : '')"
        (click)="toggleNegation(filter)"
        (removed)="removeFilter(filter)">
        @if (filter.isNegated) {
          <span class="negation-label">not</span>
          <span class="chip-label">{{ filter.chip }}:</span>
          <span class="chip-value">{{ filter.value }}</span>
        } @else if (filter.chip && !filter.isFlag) {
          <span class="chip-label">{{ filter.chip }}:</span>
          <span class="chip-value">{{ filter.value }}</span>
        } @else if (filter.isFlag) {
          <span class="chip-label flag">{{ filter.chip }}</span>
        } 
        @else {
          <span class="chip-label">* :</span>
          <span class="chip-value">{{ filter.value }}</span>
        }
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
  
      <!-- Input field for new filters -->
      <input
        matInput
        id="searchFilter"
        [formControl]="filterControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        (matChipInputTokenEnd)="addFreeTextFilter($event)"
        (input)="onInputChange(filterControl.value || '')"
        (keydown.enter)="handleEnterKey($event)"
        placeholder="Search"
        appearance="fill"
      />
    </mat-chip-grid>
  
    <!-- Autocomplete for chip names -->
    <mat-autocomplete #auto (optionSelected)="selectChip($event)">
      @for (chip of availableChips$ | async; track chip.constructor.name === 'Array' ? chip[0] : chip) {
        @let chipKey = chip.constructor.name === 'Array' ? chip[0] : chip;
        @let chipLabel = chip.constructor.name === 'Array' ? chip[1] : chip;
      <mat-option [value]="chipKey" [class.negation]="chipKey.startsWith('not ')">
        @if (chipLabel.startsWith('not ')) {
          <span class="negation-autocomplete-label">not</span>
          {{ chipLabel.substring(4) }}:
        } @else if (chips.indexOf(chipKey) >= 0) {
          {{ chipLabel }}:
        } @else {
          <i>{{ chipLabel }}</i>
        }
        @if (chipHelpers[chipKey]) {
          <span class="chip-helper">&mdash;&nbsp;{{chipHelpers[chipKey]}}</span>
        }

      </mat-option>
    }
    </mat-autocomplete>
  
    <!-- <mat-hint>{{ hint }}</mat-hint> -->
  </mat-form-field>